module.exports = __webpack_public_path__ + "static/img/call-pass-off.1f1c3415.png";